// source: livongo/protobuf/grpc/external/biometric_alerts/alertFlow.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var livongo_protobuf_common_user_biometricAlerts_pb = require('../../../../../livongo/protobuf/common/user/biometricAlerts_pb.js');
goog.object.extend(proto, livongo_protobuf_common_user_biometricAlerts_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.displayName = 'proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest;
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.GetAlertStageRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    flowTypesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest;
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFlowTypes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFlowTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values flow_types = 2;
 * @return {!Array<!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values>}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.getFlowTypesList = function() {
  return /** @type {!Array<!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.setFlowTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.addFlowTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesRequest.prototype.clearFlowTypesList = function() {
  return this.setFlowTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionAnswer: (f = msg.getQuestionAnswer()) && livongo_protobuf_common_user_biometricAlerts_pb.QuestionAnswer.toObject(includeInstance, f),
    alertId: (f = msg.getAlertId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest;
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_user_biometricAlerts_pb.QuestionAnswer;
      reader.readMessage(value,livongo_protobuf_common_user_biometricAlerts_pb.QuestionAnswer.deserializeBinaryFromReader);
      msg.setQuestionAnswer(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setAlertId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionAnswer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_user_biometricAlerts_pb.QuestionAnswer.serializeBinaryToWriter
    );
  }
  f = message.getAlertId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer question_answer = 2;
 * @return {?proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.getQuestionAnswer = function() {
  return /** @type{?proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_user_biometricAlerts_pb.QuestionAnswer, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.setQuestionAnswer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.clearQuestionAnswer = function() {
  return this.setQuestionAnswer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.hasQuestionAnswer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int64Value alert_id = 3;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.getAlertId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.setAlertId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.clearAlertId = function() {
  return this.setAlertId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.UpdateAlertStageRequest.prototype.hasAlertId = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    flowStagesList: jspb.Message.toObjectList(msg.getFlowStagesList(),
    proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse;
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.deserializeBinaryFromReader);
      msg.addFlowStages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlowStagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AlertStage flow_stages = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage>}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.prototype.getFlowStagesList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.prototype.setFlowStagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.prototype.addFlowStages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.ListFlowStagesResponse.prototype.clearFlowStagesList = function() {
  return this.setFlowStagesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.toObject = function(includeInstance, msg) {
  var f, obj = {
    alertId: (f = msg.getAlertId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    alertState: jspb.Message.getFieldWithDefault(msg, 2, 0),
    stateStartedUtc: (f = msg.getStateStartedUtc()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    stateTimeoutUtc: (f = msg.getStateTimeoutUtc()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    alertResult: jspb.Message.getFieldWithDefault(msg, 5, 0),
    question: (f = msg.getQuestion()) && livongo_protobuf_common_user_biometricAlerts_pb.Question.toObject(includeInstance, f),
    infoMap: (f = msg.getInfoMap()) ? f.toObject(includeInstance, undefined) : [],
    alertAction: jspb.Message.getFieldWithDefault(msg, 8, 0),
    alertType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    answerCodesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage;
  return proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setAlertId(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values} */ (reader.readEnum());
      msg.setAlertState(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStateStartedUtc(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStateTimeoutUtc(value);
      break;
    case 5:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values} */ (reader.readEnum());
      msg.setAlertResult(value);
      break;
    case 6:
      var value = new livongo_protobuf_common_user_biometricAlerts_pb.Question;
      reader.readMessage(value,livongo_protobuf_common_user_biometricAlerts_pb.Question.deserializeBinaryFromReader);
      msg.setQuestion(value);
      break;
    case 7:
      var value = msg.getInfoMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values} */ (reader.readEnum());
      msg.setAlertAction(value);
      break;
    case 9:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} */ (reader.readEnum());
      msg.setAlertType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswerCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlertId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getAlertState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStateStartedUtc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStateTimeoutUtc();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAlertResult();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getQuestion();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      livongo_protobuf_common_user_biometricAlerts_pb.Question.serializeBinaryToWriter
    );
  }
  f = message.getInfoMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAlertAction();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAlertType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getAnswerCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
};


/**
 * optional google.protobuf.Int64Value alert_id = 1;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getAlertId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setAlertId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.clearAlertId = function() {
  return this.setAlertId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.hasAlertId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values alert_state = 2;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getAlertState = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setAlertState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp state_started_utc = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getStateStartedUtc = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setStateStartedUtc = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.clearStateStartedUtc = function() {
  return this.setStateStartedUtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.hasStateStartedUtc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp state_timeout_utc = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getStateTimeoutUtc = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setStateTimeoutUtc = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.clearStateTimeoutUtc = function() {
  return this.setStateTimeoutUtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.hasStateTimeoutUtc = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values alert_result = 5;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getAlertResult = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setAlertResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional com.livongo.protobuf.common.user.biometricAlerts.Question question = 6;
 * @return {?proto.com.livongo.protobuf.common.user.biometricAlerts.Question}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getQuestion = function() {
  return /** @type{?proto.com.livongo.protobuf.common.user.biometricAlerts.Question} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_user_biometricAlerts_pb.Question, 6));
};


/**
 * @param {?proto.com.livongo.protobuf.common.user.biometricAlerts.Question|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
*/
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setQuestion = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.clearQuestion = function() {
  return this.setQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.hasQuestion = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * map<string, string> info = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getInfoMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.clearInfoMap = function() {
  this.getInfoMap().clear();
  return this;
};


/**
 * optional com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values alert_action = 8;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getAlertAction = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setAlertAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values alert_type = 9;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getAlertType = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setAlertType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * repeated string answer_codes = 10;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.getAnswerCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.setAnswerCodesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.addAnswerCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage} returns this
 */
proto.com.livongo.protobuf.grpc.external.biometric_alerts.AlertStage.prototype.clearAnswerCodesList = function() {
  return this.setAnswerCodesList([]);
};


goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.biometric_alerts);
